import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
	apiKey: "AIzaSyAyMbqOrGYN5Av0Sh_hly4dlI0XHHSrY-g",
	authDomain: "copypaste-90.firebaseapp.com",
	databaseURL: "https://copypaste-90.firebaseio.com",
	projectId: "copypaste-90",
	storageBucket: "copypaste-90.appspot.com",
	messagingSenderId: "567785536197"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js